var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "bv-example-row" },
    [
      _c(
        "b-row",
        { staticClass: "justify-content-md-center" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("h2", [_vm._v("Ingres a la Administración")]),
              _vm._v(" "),
              _vm.errors && _vm.errors.length
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function(error, index) {
                      return _c(
                        "div",
                        { key: index },
                        [
                          _c("b-alert", { attrs: { show: "" } }, [
                            _vm._v(_vm._s(error.message))
                          ])
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-form",
                { on: { submit: _vm.onSubmit } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "f_email",
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: "Correo electrónico"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: { id: "email", state: _vm.state },
                        model: {
                          value: _vm.login.email,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.login,
                              "email",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "login.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        id: "f_password",
                        horizontal: "",
                        "label-cols": 4,
                        breakpoint: "md",
                        label: "Contraseña"
                      }
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          type: "password",
                          id: "password",
                          state: _vm.state
                        },
                        model: {
                          value: _vm.login.password,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.login,
                              "password",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "login.password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    { attrs: { type: "submit", variant: "primary" } },
                    [_vm._v("Entrar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ef68022e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef68022e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = null
// module chunks = 